import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'QuickCom';

const ROUTE_TITLES = {
  '/login': 'Connexion',
  '/forgoutPassword': 'Mot de passe oublié',
  '/select-account': 'Sélectionner un compte',
  '/changePassword': 'Changer le mot de passe',
  '/settings/change-password': 'Changer le mot de passe',

  '/activite': 'Activité',
  '/catalogue': 'Catalogue',
  '/NewCategoryForm': 'Nouvelle catégorie',
  '/NewRemiseForm': 'Nouvelle remise',
  '/NewBrandForm': 'Nouvelle marque',
  '/NewProductForm': 'Nouveau produit',

  '/clients': 'Clients',
  '/clients/new': 'Nouveau client',
  '/fidelite': 'Fidélité',
  '/pointage': 'Pointage',
  '/retours': 'Retours & échanges',
  '/caisse': 'Caisse',

  '/settings': 'Paramètres',
  '/stock': 'Stock',
  '/calander': 'Calendrier',
  '/technical-files': 'Fiches techniques',
  '/marketing': 'Marketing',
  '/integrations': 'Intégrations',
  '/storefront': 'Vitrine',
  '/marketplace': 'Marketplace',
};

// Patterns for dynamic routes (order matters — more specific first)
const DYNAMIC_PATTERNS = [
  { pattern: /^\/clients\/stats\/[^/]+$/, title: 'Statistiques client' },
  { pattern: /^\/clients\/edit\/[^/]+$/, title: 'Modifier le client' },
  { pattern: /^\/catalogue\/edit\/[^/]+$/, title: 'Modifier la catégorie' },
  { pattern: /^\/catalogue\/discount\/edit\/[^/]+$/, title: 'Modifier la remise' },
  { pattern: /^\/catalogue\/brand\/edit\/[^/]+$/, title: 'Modifier la marque' },
  { pattern: /^\/catalogue\/product\/edit\/[^/]+$/, title: 'Modifier le produit' },
  { pattern: /^\/catalogue\/products\/[^/]+\/variants\/new$/, title: 'Nouvelle variante' },
  { pattern: /^\/catalogue\/products\/edit\/[^/]+\/variants\/[^/]+$/, title: 'Modifier la variante' },
];

function resolveTitle(pathname) {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  for (const { pattern, title } of DYNAMIC_PATTERNS) {
    if (pattern.test(pathname)) return title;
  }
  return null;
}

/**
 * Automatically sets document.title based on the current route.
 * Format: "<Page Title> — QuickCom"
 */
export function usePageTitle(overrideTitle) {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = overrideTitle || resolveTitle(location.pathname);
    document.title = pageTitle ? `${pageTitle} — ${BASE_TITLE}` : BASE_TITLE;
  }, [location.pathname, overrideTitle]);
}

/**
 * Component version — drop inside any layout to auto-manage titles.
 */
export function PageTitleManager() {
  usePageTitle();
  return null;
}

